import { render } from "./AtendimentoCategoriaRelatorio.vue?vue&type=template&id=901dfc0c&scoped=true"
import script from "./AtendimentoCategoriaRelatorio.vue?vue&type=script&lang=js"
export * from "./AtendimentoCategoriaRelatorio.vue?vue&type=script&lang=js"

import "./AtendimentoCategoriaRelatorio.vue?vue&type=style&index=0&id=901dfc0c&scoped=true&lang=css"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-901dfc0c"]])

export default __exports__